import { loadImageFile, useCurrentTenantId, useImageCache } from '@pbk-web/state';
import { useRandomProfilePicture } from '@pbk-web/utils';
import type { FC, ReactElement } from 'react';
import { useEffect, useState } from 'react';

type UploadedImageProps = {
  uniqueId: string;
  fileId?: string;
  className?: string;
  placeholder?: ReactElement;
};

const isLocal = location.host.indexOf('localhost') !== -1;

const UploadedImage: FC<UploadedImageProps> = (props) => {
  const { fileId, className, placeholder, uniqueId } = props;
  const { getImage, setImage } = useImageCache();
  const [image, setLocalImage] = useState<string | null>(null);
  const randomImageUrl = useRandomProfilePicture(uniqueId);
  const currentTenantId = useCurrentTenantId((x) => x.value);

  useEffect(() => {
    setLocalImage(null);
    if (!currentTenantId) return;

    if (isLocal && uniqueId) {
      setLocalImage(randomImageUrl);
    } else if (fileId) {
      const cachedImage = getImage(fileId);
      if (cachedImage) {
        setLocalImage(cachedImage);
        return;
      }

      loadImageFile(fileId).then((fileBlob) => {
        if (!fileBlob) return;
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result as string;
          setLocalImage(base64String);
          setImage(fileId, base64String);
        };
        reader.readAsDataURL(fileBlob);
      });
    }
  }, [currentTenantId, fileId, getImage, randomImageUrl, setImage, uniqueId]);

  if (image) return <img src={image} className={className} alt="" />;
  return placeholder ?? null;
};

export default UploadedImage;
